<template>

   <v-text-field :label="label" :value="displayDate" ref="textbox" style="width:100%" 
   @change="changed" @focus="focused" @blur="blurred" @dblclick.stop="" :hide-details="hideDetails" :persistent-hint="!hideDetails" :hint="dueString(value)"/>

</template>

<script>

//
import StringHelpers from '../helpers/StringHelpers'
import {format} from 'date-fns'
import DateHelpers from '../helpers/DateHelpers'
import { dateFormats } from '../helpers/DateHelpers'
import { getYear, addWeeks, addMonths, addDays } from 'date-fns'


export default {
    data() {
        return {
            sourceText: this.value,
            editing: false
        }
    },
    
    props: {
        label: String,
        value: String,
        hideDetails: Boolean,
        short: Boolean,
        baseDate: {
            default: format(new Date(), dateFormats.BACKWARDS),
            type: String
        }
    },

    computed: {
        displayDate() {
            //let date =  moment(this.value, 'YYYY-MM-DD').format(this.displayFormat)
            if(!this.value)
                return ''
            let date = format(this.backwardsToDate(this.value), this.displayFormat)
   
            return date
        },

        displayFormat() {
            if(this.short)
                return 'd/M/yy'
            else
                return 'EEEE d MMM yyyy'
        }
    },

    methods: {
        backwardsToDate(dateStr) {
            return DateHelpers.backwardsToDate(dateStr)
        },

        dueString(date) {
            if(!date)
                return ''
            return StringHelpers.dueString(this.backwardsToDate(date))
        },
        editDate() {
            this.editing = true
            setTimeout(() => {
                let textbox = this.$refs.textbox
            
                textbox.focus()
         
            },300)
        },
        // emitInput(val) {
        //     this.$emit('input', val)
        // },
        changed(val) {
            console.log('changed', val)
            if(val)
                val = this.formatDate(val)
            else
                val = null
            console.log('converted', val)

            this.$emit('input', val)
            this.$emit('change')

            //this.editing = false

            return true
        },

        blurred() {

        },

        focused() {
  
        },

        formatDate(val) {
            const startingDate = DateHelpers.backwardsToDate(this.baseDate) || (new Date())
            const timeFrameObj = DateHelpers.findTimeframeInString(val, startingDate)
            return DateHelpers.dateToBackwards(timeFrameObj.date)
        },

    },

}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// DateBox.vue?250aa97b